/* Application: Donations
 ========================================================================== */

app.icheck = function () {
    'use strict';

    $('input').iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green'
    });

    $('.donation-types input').iCheck({
        checkboxClass: 'icheckbox_square-white',
        radioClass: 'iradio_square-white',
        hoverClass: ' '
    });

};
